import { render, staticRenderFns } from "./VerMicrositio.vue?vue&type=template&id=6228e0bd&"
import script from "./VerMicrositio.vue?vue&type=script&lang=js&"
export * from "./VerMicrositio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports